import visitorsClassicScenario from 'garaje/mirage/scenarios/visitors-classic';

/**
 * Sets up Premium Visitors Subscription Scenario
 * - `MIRAGE_SCENARIO='visitors-premium' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 * @returns {object} scenario models
 */
export default function visitorsPremiumScenario(server) {
  const visitorsClassic = visitorsClassicScenario(server);
  const { company } = visitorsClassic;
  const vrSubscription = server.create('subscription', 'asVisitorsPremium', { company });

  company.update({ subscription: vrSubscription });
  visitorsClassic.subscription.destroy();
  visitorsClassic.subscription = vrSubscription;

  return visitorsClassic;
}
